import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { CustomModal } from "../../_components";
import { useStyles } from "./BadgeButton.styles";

const BadgeButton = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const config = {
    primary: {
      btnClass: classes.badgeBtnPrimary,
      hoverClass: classes.badgeBtnPrimaryHover,
    },
    secondary: {
      btnClass: classes.badgeBtnSecondary,
      hoverClass: classes.badgeBtnSecondaryHover,
    },
    tertiary: {
      btnClass: classes.badgeBtnTertiary,
      hoverClass: classes.badgeBtnTertiaryHover,
    },
    quaternary: {
      btnClass: classes.badgeBtnQuaternary,
      hoverClass: classes.badgeBtnQuaternaryHover,
    },
  };

  let type = "primary";

  const defaultText = t("common:default.label");

  switch (props.type) {
    case "primary":
      type = config.primary;
      break;
    case "secondary":
      type = config.secondary;
      break;
    case "tertiary":
      type = config.tertiary;
      break;
    case "quaternary":
      type = config.quaternary;
      break;
  }

  return (
    <>
      <button
        className={`${classes.badgeBtn} ${type.btnClass} ${
          props.variant === "outlined" ? classes.outlined : classes.primary
        } ${props.btnClass ? props.btnClass : ""} ${
          props.hoverEffect ? type.hoverClass : ""
        } ${
          props?.startAdornment || props?.endAdornment
            ? classes.minimizeHeight
            : classes.orignalHeight
        }`}
        onClick={() => {
          props?.btnClick ? props?.btnClick() : "";
        }}
      >
        {props?.startAdornment}
        {props.label ? props.label : defaultText}
        {props?.endAdornment}
      </button>
      {props.modal && (
        <CustomModal
          open={props.modalOpen}
          onClose={props.modalClose}
          modalBody={props.modalBody}
        />
      )}
    </>
  );
};

BadgeButton.defaultProps = {
  hoverEffect: true,
};

BadgeButton.propTypes = {
  type: PropTypes.string,
  modalSize: PropTypes.string,
  variant: PropTypes.string,
  btnClass: PropTypes.string,
  label: PropTypes.string,
  btnClick: PropTypes.func,
  endAdornment: PropTypes.node,
  startAdornment: PropTypes.node,
  modal: PropTypes.bool,
  modalOpen: PropTypes.bool,
  modalClose: PropTypes.any,
  modalBody: PropTypes.node,
  hoverEffect: PropTypes.bool,
};

export { BadgeButton };
